'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-tree-edit.routes';

export class DocumentTreeEditComponent {
  /*@ngInject*/
  constructor(dialogs, DocumentService, $stateParams, $state, $location, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.DocumentService = DocumentService;
    this.docId = $stateParams.id;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$location = $location;

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Document Upload");

    this.documentTree = documentConfig.getDocumentTree();

    // Enumeration with possible document types
    this.documentType = documentConfig.getTypes();
    this.documentPageCategories = documentConfig.getPageCategories();

    this.documentType = [];
    this.docTypesEnum = [];

    this.addPath = _ => {
      this.document.tree.push({
        path: "",
        orderNumber: 100
      });
    };

    let rFn = (node, o, parent) => {

      let _parentId = (parent) ? parent.value + "::" : "";
      let _parentName = (parent) ? parent.name + " → " : "";

      let newNode = {
        value: _parentId + node.id,
        name: _parentName + node.name,
        group: "General"
      };

      o.push(newNode);

      if (node.children && node.children.length) {
        node.children.forEach(child => rFn(child, o, newNode))
      }
    };

    this.documentTree.forEach(node => rFn(node, this.docTypesEnum));

    this.document = {};

    this.DocumentService.get({id: this.docId}, doc => {
      this.document = doc;
    }, err => {
      console.log('Could not get the document from the server.');
    });

    this.submitted = false;
  }

  removeCat(idx) {
    this.document.tree.splice(idx,1);
  }

  patch(form) {

    this.submitted = true;
    this.sendSuccess = false;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {
      this.DocumentService.update({id: this.docId}, this.document, () => {
          this.submitted = false;
          this.sendSuccess = true;

          var dlg = this.dialogs.notify("Success", "Your document has been changed successfully");
          dlg.result.then(() => {
            that.$location.url("/document-tree/list");
          });
        },
        (err) => {
          this.sendFailure = true;
        })
    }
  }
}

export default angular.module('conduuApp.documentTreeEdit', [uiRouter])
  .config(routes)
  .component('documentTreeEdit', {
    template: require('./document-tree-edit.html'),
    controller: DocumentTreeEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/tree-edit/document-tree-edit.component.js